// action types for categories
export const SET_CATEGORIES_DATA = "SET_CATEGORIES_DATA";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
